import { render, staticRenderFns } from "./ImportsStatus.vue?vue&type=template&id=67657a27&scoped=true&"
import script from "./ImportsStatus.vue?vue&type=script&lang=js&"
export * from "./ImportsStatus.vue?vue&type=script&lang=js&"
import style0 from "./ImportsStatus.vue?vue&type=style&index=0&id=67657a27&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67657a27",
  null
  
)

export default component.exports